import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Typography } from "@mui/material";
import axios from "axios";

const ViewOrder = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`https://ecom-api.applligentdemo.com/orders/getOrderById/${id}`, {
        headers: {
          Authorization: `${token}`,
        },
      })
      .then((res) => setOrder(res.data.order))
      .catch((err) => console.error("Error:", err));
  }, [id]);

  if (!order) return <p>Loading order details...</p>;

  return (
    <Card sx={{ p: 3, m: 2, backgroundColor: "#EEEFE0" }}>
      <Typography variant="h5" gutterBottom>
        Order #{order._id}
      </Typography>
      <Typography>Customer: {order.userId?.name}</Typography>
      <Typography>Email: {order.userId?.email}</Typography>
      <Typography>Status: {order.status}</Typography>
      <Typography>
        Ordered At: {new Date(order.createdAt).toLocaleString()}
      </Typography>
      <Typography variant="h6" mt={2}>
        Products:
      </Typography>
      <ul>
        {order?.items?.map((item, i) => (
          <li key={i}>
            {item.productId?.name} - Qty: {item.quantity} - ₹
            {item.productId?.price}
          </li>
        ))}
      </ul>

      <Typography mt={2}>
        <strong>Total:</strong> ₹{order.totalAmount}
      </Typography>
    </Card>
  );
};

export default ViewOrder;
